var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthSideImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 704,
    viewBox: "0 0 509 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 509,
    height: 704,
    rx: 10,
    fill: "#3C37FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_738_3189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 340,
    y: 0,
    width: 169,
    height: 192
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    width: 169,
    height: 192,
    rx: 10,
    fill: "#3C37FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_738_3189)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 70,
    r: 88,
    fill: "#2B26EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 70,
    r: 108,
    fill: "#2B26EC",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthSideImg);
export default __webpack_public_path__ + "static/media/authSideImg.41327ea03064520f9259e156cce2b0b4.svg";
export { ForwardRef as ReactComponent };